import React, { useState } from "react";

import styled from "styled-components";
import Img from "../../assets/category.png";
const Container = styled.div`
  width: 19%;
  height: auto;
  background: white;
  margin: 0 1% 0 0;
  text-align: center;
  padding: 20px 0;
  border-radius: 5px;
  cursor: pointer;
`;
const ContainerActive = styled.div`
  width: 19%;
  height: auto;
  background: #b0c8c8;
  margin: 0 1% 0 0;
  text-align: center;
  padding: 10px 0;
  border-radius: 5px;
  cursor: pointer;
  @media (max-width: 768px) {
    width: 48%;
    margin: 0 1% 1% 0;
  }
`;
const CatImg = styled.img`
  width: 50px;
  height: 50px;
`;
const Title = styled.p`
  margin: 0;
  padding: 5px;
`;
function CatView(props) {
  return (
    <ContainerActive
      onClick={() => props.catChangeHandler(props.cat._id, props.index)}
    >
      <CatImg src={props.icon} alt="img" />
      <Title>{props.cat.name}</Title>
    </ContainerActive>
  );
}

export default CatView;
